export type HelioScorePillarCopy = {
  key: string;
  name: string;
  weight: string;
  summary: string;
};

export const HELIO_SCORE_PILLARS: HelioScorePillarCopy[] = [
  {
    key: "generation_potential",
    name: "Generation Potential",
    weight: "25%",
    summary:
      "How much renewable electricity the property can produce from roof geometry, irradiance and shading.",
  },
  {
    key: "economic_opportunity",
    name: "Economic Opportunity",
    weight: "25%",
    summary:
      "Indicative savings and payback ranges at the address-only stage; refined when tariff and usage are known.",
  },
  {
    key: "energy_independence",
    name: "Energy Independence",
    weight: "20%",
    summary:
      "How much of household demand can be met on-site. Provisional until a bill unlocks consumption evidence.",
  },
  {
    key: "property_performance",
    name: "Property Performance",
    weight: "10%",
    summary: "Fabric and systems efficiency from EPC rating and floor area.",
  },
  {
    key: "smart_energy_readiness",
    name: "Smart Energy Readiness",
    weight: "10%",
    summary: "Suitability for batteries, EV charging and flexible tariffs.",
  },
  {
    key: "optimisation_potential",
    name: "Optimisation Potential",
    weight: "10%",
    summary: "Headroom to improve the score with system choices. Provisional at Preliminary.",
  },
];

export const HELIO_SCORE_PILLARS_BY_KEY: Record<string, HelioScorePillarCopy> =
  Object.fromEntries(HELIO_SCORE_PILLARS.map((pillar) => [pillar.key, pillar]));
